import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalWorkingHoursScoreService } from '../../../core/application/services/scores/get-self-digital-working-hours-score.service';
import { SelfDigitalWorkingHoursScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-working-hours-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfDigitalWorkingHoursScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalWorkingHoursScoreService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfDigitalWorkingHoursScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
